import style from './style.scss';
import Button from '../button';
import RefreshIcon from '../icons/refresh';

/**
 * The ErrorMessage component is displayed when an error occurs within a particular context,
 * for instance if a data loading error occurs. A default message is displayed if none is
 * specified in props.
 *
 * props:
 * - noRetry: set this to false if retrying is not desired
 * - isRetryPending: is a retry operation currently in progress (true or false)
 * - retryCount: how many times has the a retry been attempted without success
 * - retryHandler: handler function which is called when the retry button is clicked
 * - message: custom message
 */

const ErrorMessage = props => {

	let message = props.message || 'An error occurred and the data could not be loaded';

	if (props.retryCount > 0) {
		message += ` (retried ${props.retryCount} time${props.retryCount > 1 ? 's' : ''})`;
	}

	return (
		<div class={style.error}>
			<div class={style.error_message}>
				{ message }
			</div>
			{
				props.noRetry
					? null
					: <div class={style.error_retry}>
						<Button clickHandler={props.retryHandler} isDisabled={props.isRetryPending}>
							<RefreshIcon />
							{ props.isRetryPending ? 'Loading' : 'Retry' }
						</Button>
					</div>
			}
		</div>
	);
};

export default ErrorMessage;



// WEBPACK FOOTER //
// ./components/error/index.js